import React, { useEffect } from 'react';
import { AppInsightsErrorBoundary, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { useMEMTranslation } from '../../utils/text-utils';
import serviceLogger from './service-logger';
import { bodyContentStyles, titleCommandBarStyles } from '../../utils/common-styles';
import { PageTitle } from '../../providers/harmony-scope/lazy-enablers';
import { BannerMessagesContainer } from '../../shared-components/banner-messages-container';
import { useAppDispatch } from '../../ducks/hooks';
import { addError, EBannerType } from '../../ducks/banner-messages/duck-banner-messages';
import { useBuildICMProperties, useTrackICMEvent } from './hooks';
import { EICMType, EICMSeverity } from '../../enums/icm-enum';
import { usePageContext } from '../../utils/page-context';

export const ErrorComponent = () => {
  const { t } = useMEMTranslation();
  const dispatch: any = useAppDispatch();
  const errorLogged = React.useRef<boolean>(false);
  const trackICMEvent = useTrackICMEvent();
  const pageName = usePageContext();
  const buildICMProperties = useBuildICMProperties();

  useEffect(() => {
    if (!errorLogged.current) {
      errorLogged.current = true;
      dispatch(
        addError({
          message: t('errorLoadingTryAgain'),
          bannerType: EBannerType.PageError,
        })
      );
      const icmProps = buildICMProperties(EICMType.Critical, EICMSeverity.Sev3);
      trackICMEvent('CRITICAL ERROR ON MEM PAGE', pageName, '', icmProps);
    }
  }, [buildICMProperties, dispatch, pageName, t, trackICMEvent]);

  return (
    <div style={bodyContentStyles}>
      <div style={titleCommandBarStyles}>
        <PageTitle>{t('appTitle')}</PageTitle>
      </div>
      <BannerMessagesContainer />
    </div>
  );
};

export const ErrorBoundary = (props: React.PropsWithChildren) => {
  const { children } = props;

  return (
    <AppInsightsErrorBoundary onError={ErrorComponent} appInsights={serviceLogger.reactPlugin as ReactPlugin}>
      {children as React.ReactElement<any>}
    </AppInsightsErrorBoundary>
  );
};
